import Image from 'next/image'
import loaderImage from '../../assets/images/loader.gif'
import { Fragment } from 'react'

const FullPageLoader = ({ open }: any) => {
  return (
    <Fragment>
      <div className={`${!open ? 'hidden' : ''}`}>
        <div
          className={` fixed z-10 top-0 left-0 bottom-0 right-0 w-full h-full bg-black-100 opacity-50 pointer-events-none ${
            open ? 'flex' : 'hidden'
          }`}
        />
        <div className="w-full h-full inset-0 fixed flex items-center justify-center z-10">
          <div className=" w-[120px] h-[120px] flex items-center justify-center z-50 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <div className="flex items-center justify-center">
              <Image src={loaderImage} alt="loader" className="h-8 w-auto" />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default FullPageLoader
